import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-4 gap-3" }

import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const names = [
  'simple-scale',
  'continuous-intervals',
  'discrete-intervals',
  'arpeggio',
  'rhythm'
]
const exerciseRoutes = useRouter().getRoutes().filter(r => names.includes(String(r.name )))

return (_ctx: any,_cache: any) => {
  const _component_va_card_title = _resolveComponent("va-card-title")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_card = _resolveComponent("va-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(exerciseRoutes), (route, index) => {
        return (_openBlock(), _createBlock(_component_va_card, {
          key: index,
          gradient: "",
          color: "color5",
          href: route.path,
          class: "col cursor-pointer hover:opacity-80 md:h-36"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_va_card_content, null, {
              default: _withCtx(() => [
                _createVNode(_component_va_card_title, { class: "text-2xl" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(route.meta.routeTitle), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["href"]))
      }), 128))
    ])
  ]))
}
}

})